const messages = {
  fr: {
    anmobi: {
      title: "WEBI MOBILE",
      loading: "Chargement en cours...",
      ouverture_session: "ouverture de session en cours..",
      echec_ouverture_session: "echec lors de l'ouverture de session",
      succes_ouverture_session: "Session ouverte avec succès...",
      fermeture_de_session: "fermeture de session en cours...",
      session_fermee: "session fermé avec succés",
      choix_etablissement: "Sélectionner votre établissement :",
      access_pointage_perso: "Accéder au pointage du personnel ",
      access_pointage_famille: "Accéder au pointage des familles ",
      error_server: "Oups ! Une erreur est survenu lors du traitement de votre requête. Veuillez recommencer",
      logout: {
        main_title: "Ecran de déconnexion",
        component_main_title: "Pour vous déconnecter, veuillez saisir votre code secret.",
        bt_back: "CORRIGER",
        bt_valide: "VALIDER",
        bt_del: "ANNULER",
        result_msg_false:
          "Le code secret que vous avez saisi est incorrect. Veuillez recommencer."
      },

      etablissement: {
        selectionner: " Sélectionner votre établissement : "
      },
      modalVerification: {
        quit_msg: " Vous êtes sur le point de vous déconnecter de l'application",
        confirmation_quit: "Etes-vous sûr de vouloir quitter l'application ?",
        quit_app: "Se déconnecter de l'application",
        stay_app: "Rester sur l'application",
        btn_quit_app: "Quitter l'application",
        btn_no_quit_app: "Rester sur l'application",
        title_etab: "Changement d'établissement",
        confirmation_change: "Etes-vous sûr de vouloir changer d'établissement ?",
        btn_changer_etab: "Changer d'établissement",
        btn_pas_changer_etab: "Ne pas changer d'établissement",
        message_date: "Selectionnez une date",
        date_picker_quit: "Quitter",
        date_picker_validate: "Valider",
        annuler: "Annuler",
        valider: "Valider",
        changement_utilisateur: "Changement d'utilisateur",
        alert_perte_donnes: "Attention, en vous connectant sur un autre profil, toutes vos données actuelles seront supprimées"

      },
      login: {
        connectezvous: "Connectez-vous",
        valider: "Valider",
        annuler: "Annuler",
        identifiants_manquants: "Veuillez renseigner tous les champs puis reessayer",
        identifiants_incorrects: "Identifiants incorrects, Veuillez reessayer",
        codepin: "Code PIN incorrect, Veuillez reessayer",
        no_activites: "Aucune activité n'a été trouvée pour cet utilisateur. Vérifiez votre paramétrage",
        no_etablissements: "Aucun établissement n'a été trouvée pour cet utilisateur. Vérifiez votre paramétrage ",
        another_user: "L'utilisateur ne correspond pas à la clé produit MOBI AN"

      },
      home: {
        msg_bienvenue: "L'application tactile de pointage des activités & ateliers iNoé",
        fiches_individus: "Fiches Individus",
        pointages: "Pointages",
        navettes: "Navettes",
        parametres: "Paramètres",
        changer_etablissement: "Changer d'établissement",
        quitter: "Quitter"
      },
      pointage_seance: {
        confirmation_pointage_masse: "Voulez vous vraiment pointer les enfants pour la séance du ",
        annulation_pointage_masse: "Voulez vous vraiment annuler le pointage des enfants pour la séance du "
      },
      activite: {
        selectionner_votre_activite: "Sélectionnez votre activité",
        aucune_activite: "Aucune activité n'est prévue pour la date sélectionnée",
        categotieActivite: {
          ACCUEIL_LOISIRS: "Accueil de loisirs",
          ATELIER: "Atelier",
          PERISCOLAIRE: "Périscolaire",
          RESTAURATION: "Restauration",
          SECTEUR_JEUNES: "Secteur jeunes",
          SEJOUR: "Séjour",
          TACHES_ACCUEIL: "Taches accueil",
          GESTION_SCOLAIRE: "Gestion scolaire",
          RAMASSAGE: "Navette",
        }
      },
      information: {
        autorisation: {
          rentre_autorisations: "Rentre seul", // Retour d'Erik (Rentre Seul au lieu de Rentre autorisations)
          photographie: "Photographie",
          hospitalisation: "Hospitalisation",
          prise_de_medicaments: "Prise de médicaments",
          diffusion_photos_video: "Diffusion photos/vidéo",
          sortie: "Sortie",
          transport: "Transport",
        },
        aucun_champ_libre_a_afficher: "Aucun champ libre à afficher",
        oui: "Oui",
        non: "Non",
        ne_le: "Né le",
        nee_le: "Née le",
        regime_alimentaire: "Régime alimentaire",
        tel: "Tél",
        tel_pro: "Tél pro",
        portable_perso: "Portable perso",
        portable_pro: "Portable pro",
        pas_de_parents: "Pas de parents",
        medecin: "Médecin",
        maladies: "Maladie(s)",
        pas_de_medecin: "Pas de médecin",
        detailsvisible_des_vaccins: "Vaccin(s)",
        aucune_maladie: "Aucune maladie",
        aucun_vaccin: "Aucun vaccin",
        aucune_allergie: "Aucune allergie",
        allergie: "Allergie(s)",
      },

      informationApplication: {
        titre: "Informations",
        editeur: "Editeur :",
        adresse: "110, Avenue Barthélémy Buyer, 69009 LYON",
        numtel: "04.72.53.22.00",
        email: "aiga@aiga.fr"
      },
      filtres: {
        btn_annuler: "Annuler le filtrage",
        btn_fermer: "Fermer",
        btn_annuler_action: "Annulation Pointage de masse",
        empty_liste: "La liste est vide.",
        title_filtre_individu: "Filtrer les individus par",
        badge_actif: "actif",
        span_age: "Age",
        span_ecole: "Ecole",
        span_classe: "Classe",
        span_niveau: "Niveau scolaire",
        span_instit: "Instituteur(rice)",
        span_ville: "Ville",
        title_filtre_affichage: "Options d'affichage",
        nom_prenom: "NOM & Prénom",
        prenom_nom: "Prénom & NOM",
        autori_diffu: "Diffusion Photo/video",
        autori_hospi: "Hospitalisation",
        autori_medoc: "Prise de médicaments",
        autori_photo: "Photographie",
        autori_rentre: "Rentre seul(e)",
        autori_transport: "Transports",
        autori_regime: "Régime alimentaire",
        autori_sorties: "Activités ext (sorties)",
        title_filtre_pointage: "Options de pointage",
        filtre_temps: "Temps d'accueil",
        filtre_groupe: "Groupes",
        filtre_pointage: "Type de pointage",
        title_filtre_age: "Les individus agés",
        btn_filtre_age: "Filtrer par age",
        title_filtre_ecoles: "Sélectionnez le ou les écoles",
        btn_filtre_ecoles: "Filtrer par écoles",
        title_filtre_classes: "Sélectionnez la ou les classes",
        btn_filtre_classes: "Filtrer par classes",
        title_filtre_niveau: "Sélectionnez le ou les niveaux",
        btn_filtre_niveau: "Filtrer par niveaux",
        title_filtre_ville: "Sélectionnez la ou les villes",
        btn_filtre_ville: "Filtrer par ville",
        btn_rechercher: "Rechercher",
        title_filtre_instit: "Sélectionnez par instituteur(rice)",
        btn_filtre_instit: "Filtrer par Instituteur(rice)",
        title_filtre_vous_desirez: "Vous désirez afficher",
        title_filtre_groupe: "Sélectionnez le ou les groupes",
        btn_valider: "Valider",
        filtre_option_sans_presence: "Individus sans pointage en réel",
        filtre_option_sans_pointage: "Individus sans aucun pointage",
        filtre_option_reservation: "Individus avec des réservations",
        filtre_option_presence: "Individus avec des présences",
        filtre_option_absence: "Individus avec des absences",
        filtre_option_orphelin: "Individus sans heure de fin"
      },
      erreurs: {
        default: "Oups ! Une erreur est survenue lors du traitement de votre requête. Veuillez recommencer.",
        fail_pointage: "Attention, le pointage n'a pas pu être réalisé",
        no_regime: "Aucun régime alimentaire disponible",
        no_seance: "Aucune séance disponible pour l'activité",
        no_palette: "Aucune palette de pointage disponible",
        no_previsionnel: "Aucun pointage prévisionnel à reporter",
        no_individus: "Aucun individu n'est inscrit pour l'activité ",
        no_internet: "Impossible d'accéder aux serveurs Aiga. Si c'est la première fois que vous lancez l'application, veuillez vérifier votre connexion internet.",
        access_denied: "Accès refusé : Clé du produit incorrect."
      }
    }
  }
};
export default messages;
